import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import Table from "../../../../../../components/Table";
import BaseListPage from "../../../../../../base/BaseListPage";
import Presenter from "../../../../../ReferenceTable/schedule-template/schedule/shdedule-form/schedule-page/Presenter";
import SearchSelect from "../../../../../../components/searchSelect/SearchSelect";
import { Button } from "nq-component";
import AdditionalTalbePresenter from "../../additional-info/AdditionalTalbePresenter";
import InputFactory from "../../../../../../components/InputFactory";
import { DialogConfirmation } from "../../../../../../components/common/Converter";

export default class ContributionDeduction extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      contribution_type: [],
      scheduleTemplate: [],
      selectedContribution: "",
      amount: "",
      startDate: "",
      objects: [],
      initialData: [],
      contribution_method: "",
      fix: "",
      formula: "",
      error: false,
      objectID: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const contribution_type = await findObjectUseCase().execute(
      "contribution_type"
    );
    const newObject = await findObjectUseCase().execute("contributions", {
      where: { empID: this.props.object.id },
    });

    // const newObject = contribution.filter(
    //   (item) => item.email === this.props.object.email
    // );
    this.setState({
      contribution_type,
      // object: newObject,
      initialData: newObject,
      // contribution,
    });
  }

  getCollectionName() {
    return "contributions";
  }

  getCurrent() {
    return this.props.object.id;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.contribution)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.contribution)
      );
      if (newObjects.length > 0) {
        localStorage.setItem("Contributions", JSON.stringify(newObjects));
      }
    }
  }

  async handleDeleteData(data) {
    // const collectionData = await findObjectUseCase().execute("contributions");
    // const deletedData = collectionData.filter((item) => item.id === id);
    // const prevDelete =
    //   JSON.parse(localStorage.getItem("DeleteContribution")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem(
    //   "DeleteContribution",
    //   JSON.stringify(updatedDeleteData)
    // );

    // await this.presenter.deleteObjectUseCase.execute("contributions", id);
    // this.refetchData();
    DialogConfirmation(
      data.id,
      "contributions",
      () => this.refetchData(),
      true
    );
  }

  async handleEditObject(object) {
    const date = new Date(object.startdate);
    const formattedDate = date.toISOString().slice(0, 10);
    const { contribution_method } =
      (await findObjectUseCase().execute("contribution_type")).find(
        ({ contributionType }) => contributionType === object.contribution
      ) || {};
    this.setState({
      objectID: object.id,
      selectedContribution: object.contribution,
      amount: object.amount,
      startDate: formattedDate,
      contribution_method,
    });
  }

  async refetchData() {
    // const contri = await findObjectUseCase().execute("contributions");
    const objects = this.presenter.getObjects();
    return objects;
  }

  async handleAllowanceChange(selectedContribution) {
    const contributionType = await findObjectUseCase().execute(
      "contribution_type"
    );
    const filterContribution = contributionType.filter(
      (data) => data.contributionType === selectedContribution
    );
    const contribution_methods = filterContribution.map(
      (data) => data.contribution_method
    );
    const fix = filterContribution.map((data) => data.fix);
    const formula = filterContribution.map((data) => data.formula);
    const contribution_method = contribution_methods.join(", ");
    this.setState({
      selectedContribution,
      contribution_method,
      fix,
      formula,
      objectID: "",
    });
  }
  handleAmountChange(amount) {
    this.setState({ amount: amount.toString() });
  }

  handleStartDate(startDate) {
    this.setState({ startDate });
  }

  async dataValidation() {
    const contri = await findObjectUseCase().execute("contributions");
    console.warn("STAT:: ", this.state.selectedContribution);
    const validate = contri.some(
      (item) =>
        item.contribution === this.state.selectedContribution &&
        item.empID === this.props.object.id
    );

    return validate;
  }

  async objectData(amount, employeeEmail, empID) {
    const data = {
      email: employeeEmail,
      empID,
      contribution: this.state.selectedContribution,
      amount,
      startdate: this.state.startDate,
    };

    const dataExists = await this.dataValidation();
    console.warn("vlid: ", dataExists);

    if (dataExists) {
      this.setState({ error: true });
      return;
    } else {
      await upsertUseCase().execute("contributions", data);
      this.setState({
        objectID: "",
        selectedContribution: "",
        amount: "",
        startDate: "",
        error: false,
      });
    }
    this.refetchData();
    this.refetchData();
  }

  async handleSaveClick() {
    let employeeEmail = this.props.object.email;
    let empID = this.props.object.id;
    if (this.state.objectID !== "") {
      const updateData = {
        email: employeeEmail,
        empID,
        contribution: this.state.selectedContribution,
        amount: this.state.amount,
        startdate: this.state.startDate,
        id: this.state.objectID,
      };
      await upsertUseCase().execute("contributions", updateData);
      this.setState({
        objectID: "",
        selectedContribution: "",
        amount: "",
        startDate: "",
        error: false,
      });
      this.refetchData();
      this.refetchData();
    } else {
      if (this.state.contribution_method === "INPUT AMOUNT") {
        this.objectData(this.state.amount, employeeEmail, empID);
      } else if (
        this.state.contribution_method === "FIX AMOUNT" &&
        this.state.fix !== ""
      ) {
        this.objectData(this.state.fix.join(", "), employeeEmail, empID);
      } else if (
        this.state.contribution_method === "FORMULA" &&
        this.state.formula !== ""
      ) {
        this.objectData(this.state.formula.join(", "), employeeEmail, empID);
      }
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      loading,
      selectedContribution,
      contribution_method,
      contribution_type,
      current,
      count,
      limit,
    } = this.state;
    const { isViewMode } = this.props;

    let isDisable = false;

    if (
      contribution_method === "INPUT AMOUNT" &&
      (!this.state.amount || !this.state.startDate)
    ) {
      isDisable = true;
    } else if (
      (contribution_method === "FIX AMOUNT" ||
        contribution_method === "FORMULA") &&
      !this.state.startDate
    ) {
      isDisable = true;
    }

    return (
      <>
        <div className="m-4">
          {!isViewMode && (
          <div className="p-1 mb-4 w-100">
            <div className="row">
              <div className="col-lg-2">
                <SearchSelect
                  value={selectedContribution}
                  onChange={this.handleAllowanceChange.bind(this)}
                  options={contribution_type.map((contribution) => ({
                    label: contribution.contributionType,
                    value: contribution.contributionType,
                  }))}
                />
              </div>

              {contribution_method === "INPUT AMOUNT" && (
                <div className="col-lg-2">
                  <InputFactory
                    type="String"
                    _type="DecemalNum"
                    value={this.state.amount}
                    placeholder="Contribution Amount"
                    field="amount"
                    onChange={this.handleAmountChange.bind(this)}
                  />
                </div>
              )}
              <div className="col-lg-2">
                <InputFactory
                  value={this.state.startDate}
                  placeholder="start Date"
                  type="Date"
                  field="startdate"
                  onChange={this.handleStartDate.bind(this)}
                />
              </div>
              <div className="col-lg-2">
                <Button
                  className="btn btn-primary"
                  type="button"
                  onClick={this.handleSaveClick.bind(this)}
                  disabled={isDisable || !this.state.selectedContribution}
                >
                  Save
                </Button>
              </div>

              <div className="col-lg-4">
                <p
                  className="fs-6 fw-bold text-danger text-center mt-2"
                  style={{ display: !this.state.error ? "none" : "block" }}
                >
                  You cannot add same contribution.
                </p>
              </div>
            </div>
          </div>
          )}

          <Table
            objectId={!isViewMode ? this.handleDeleteData.bind(this) : undefined}
            objectData={!isViewMode ? this.handleEditObject.bind(this) : undefined}
            refetch={this.refetchData.bind(this)}
            progress={loading}
            fields={schema.fields}
            objects={objects}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            {...(!isViewMode && {
              actionsList: [
                {
                  label: <i className="bi bi-pen" />,
                  actionType: "object",
                },
                {
                  label: <i className="bi bi-trash" />,
                  actionType: "delete",
                },
              ],
            })}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["id", "Created At", "Updated At", "name"]
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
